import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-black text-white py-8">
      <div className="container mx-auto px-4 grid md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div>
          <h3 className="text-xl font-bold mb-4">Confesz</h3>
          <p className="text-gray-400">Free social media platform</p>
        </div>
        
        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-4">Quick Links</h4>
          <nav className="space-y-2">
            <Link to="/" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">Home</Link>
            <Link to="/downloads" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">Downloads</Link>
            <Link to="/about" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">About Us</Link>
            <Link to="/contact" className="clickable block hover:text-yellow-400 transition-colors duration-300 bg-transparent">Contact</Link>
          </nav>
        </div>
        
        {/* Contact */}
        <div>
          <h4 className="font-semibold mb-4">Contact</h4>
          <p>Email: <a href="mailto:confesz@tech-center.com" className="clickable hover:text-yellow-400 transition-colors duration-300 bg-transparent">confesz@tech-center.com</a></p>
        </div>
        
        {/* Social Media */}
        <div>
          <h4 className="font-semibold mb-4">Follow Us</h4>
          <div className="flex space-x-4">
            <a href="#" className="clickable hover:text-blue-500">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="clickable hover:text-blue-400">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="clickable hover:text-pink-500">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="clickable hover:text-red-500">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="text-center mt-8 pt-4 border-t border-gray-900">
        <p>&copy; {new Date().getFullYear()} Confesz. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;